import { useContext, useState } from "react";
import ConsoleUI from "./_Console.presenter";
import { useRouter } from "src/hooks/useRouter";
import { maxLengthValidation } from "src/utils/validation";
import { notifySuccess, notifyWarning } from "src/components/Common/Toast";
import { useMutation, useQueryClient } from "react-query";
import { updateCashStatus, updateServiceName } from "src/service/pay";
import { useApiError } from "src/hooks/useApiError";
import { deleteService } from "src/service/cloud";
import { useCheckConsole } from "src/hooks/validation/useCheckConsole";
import useCompleteMsgModal from "src/hooks/Modal/useCompleteMsgModal";
import useGuideDownloadModal from "src/hooks/Modal/useGuideDownloadModal";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { ModalsDispatchContext } from "src/context/Modal/Console/ConsoleModal.context";
import { ModalsStateContext } from "src/context/Modal/Console/ConsoleModal.context";
import { useGetCashStatus } from "src/hooks/api/pay/useGetCashStatus";
import { useGetPayUnregisterBill } from "src/hooks/api/bill/useGetPayUnregisterBill";
import { useGetPromotionUnregisterBill } from "src/hooks/api/bill/useGetPromotionUnregisterBill";
import { useSiteNxacList } from "src/hooks/api/nxac/useSiteNxacList";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useTranslation } from "react-i18next";

interface IConsoleContainerProps {}
const ConsoleContainer = () => {
  const [viewType, setViewType] = useState<string>("detail");
  const [promotionNotice, setPromotionNotice] = useState<string>("");
  const [modal, setModal] = useState({
    confirmServiceNameIsActive: false,
    confirmDeleteIsActive: false,
  });
  const [makeType, setMakeType] = useState<string>("");
  const [isDone, setIsDone] = useState<boolean>(false);
  const [promotionCode, setPromotionCode] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [serviceNotice, setServiceNotice] = useState<string>("");
  const [nowTime, setNowTime] = useState();
  const [createPercent, setCreatePercent] = useState<number>(0);
  const [showCashRequestDel, setShowCashRequestDel] = useState<boolean>(false);

  // handleChange
  const [newServiceName, setNewServiceName] = useState<string>("");
  const [deleteCashReqMsg, setDeleteCashReqMsg] = useState<string>("");

  const { serviceBillUid, showSiteNewModal } = useContext(ModalsStateContext);
  const { setShowSiteNewModal, setServiceBillUid } = useContext(
    ModalsDispatchContext
  );
  const { showMsgModal, setShowMsgModal, closeButtonMsg } =
    useCompleteMsgModal();
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({});
  const { isLoading: unregisterPayLoading, unregisterPayList } =
    useGetPayUnregisterBill({
      onSuccess: (data) => {
        if (data?.length > 0) {
          setServiceBillUid(data?.[0]?.serviceBillUid ?? "");
        }
      },
    });
  const { isLoading: unregisterPromotionLoading, unregisterPromotionList } =
    useGetPromotionUnregisterBill({
      onSuccess: (data) => {
        if (data?.length > 0) {
          setServiceBillUid(data?.[0]?.serviceBillUid ?? "");
        }
      },
    });
  const { userCashStatusLoading, userCashStatus, userCashStatusRefetch } =
    useGetCashStatus({ onSuccess: () => {} });

  const { siteNxacList } = useSiteNxacList({
    serviceUid: serviceList ? serviceList[0]?.serviceUid : "",
  });
  const { isDspProduct } = useProductFlags();
  const queryClient = useQueryClient();
  const {
    showGuideDownloadModal,
    setShowGuideDownloadModal,
    doNotOpenGuide,
    setDoNotOpenGuide,
    detailIndex,
    setDetailIndex,
    // openEco,
    goEcoAdmin,
    handleChangeGuide,
    closeButtonGuide,
  } = useGuideDownloadModal();
  const { t } = useTranslation();
  const { openEco, openWrapsody, goSiteType, goSitePromotion, goConsole } =
    useRouter();
  const { handleError } = useApiError();

  const { mutateAsync: mutateUpdateServiceName } = useMutation(
    "updateServiceName",
    updateServiceName,
    {
      onSuccess: (data) => {
        // 알아보자
        // serviceList[detailIndex].serviceName = newServiceName
        // this.setState({
        //   serviceList
        // })
        toggleModalConfirmServerName();
      },
      onError: handleError,
    }
  );
  const { mutateAsync: mutateDeleteService } = useMutation(
    "deleteService",
    deleteService,
    {
      onSuccess: (data) => {
        goConsole();
      },
      onError: handleError,
    }
  );
  // const { applyCheckPromotionCodeList } = useApplyCheckPromotionCode({});
  // if (isDsfProduct) {
  //   applyCheckPromotionCode({
  //           product: getProductFromSessionStorage(),
  //         }).then((res)=>{

  //           console.log("res", res);
  //         })
  // }
  useCheckConsole({
    isMyServiceLoading:
      isMyServiceLoading || unregisterPayLoading || unregisterPromotionLoading,
    unregisterPay: unregisterPayList ?? [],
    unregisterPromotion: unregisterPromotionList ?? [],
    serviceList,
    setShowSiteNewModal,
    setMakeType,
    setDoNotOpenGuide,
    setServiceNotice,
    setCreatePercent,
    detailIndex,
    setShowMsgModal,
    setIsDone,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.target?.name) {
      case "deleteCashReqMsg":
        setDeleteCashReqMsg(e.target.value);
        break;
      case "newServiceName":
        setNewServiceName(e.target.value);
        break;
    }
  };

  const guideDownloadModal = () => {
    setShowGuideDownloadModal(true);
  };

  const newSite = () => {
    goSiteType();
  };

  const goDetail = (index: number) => {
    setViewType("detail");
    setDetailIndex(index);
  };

  const goList = () => {
    setViewType("list");
  };

  const toggleModalConfirmServerName = () => {
    setModal((prev) => ({
      ...prev,
      confirmServiceNameIsActive: !prev.confirmServiceNameIsActive,
    }));
    setNewServiceName("");
  };

  const toggleModalConfirmDelete = () => {
    setModal((prev) => ({
      ...prev,
      confirmDeleteIsActive: !prev.confirmDeleteIsActive,
    }));
  };

  const confirmServiceName = () => {
    const newServiceNameLength = maxLengthValidation(newServiceName, 50);

    if (!newServiceNameLength) {
      // notifyWarning(
      //   t(
      //     "siteManagement.createSiteModal.siteNameCheckMsg",
      //     50
      //   )
      // );
      return;
    }
    // 해당 요청 알아볼것
    mutateUpdateServiceName({
      serviceUid: serviceList ? serviceList[detailIndex]?.serviceUid : "",
      serviceName: newServiceName,
    }).then(() => {
      queryClient.invalidateQueries("getMyServiceList");
    });
    // const result = await PayActions.updateServiceName(
    //   serviceList[detailIndex].serviceUid,
    //   newServiceName
    // )

    // if (result) {
    //   serviceList[detailIndex].serviceName = newServiceName
    //   this.setState({
    //     serviceList
    //   })
    //   // 뒷처리
    // } else {
    //   // 에러 처리
    // }

    // this.toggleModalConfirmServerName()
  };

  const confirmServiceDelete = () => {
    const sleep = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));

    // 무엇?
    // this.commonStore.setLoading(true)

    // serviceUid에 어떤값 넣어야 하는지 확인!
    mutateDeleteService({
      serviceUid: serviceList ? serviceList[detailIndex]?.serviceUid : "",
    });

    // const result = await ServiceActions.deleteService(
    //   serviceList[detailIndex].serviceUid
    // )
    // await sleep(5000)
    // window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`

    // 로딩 컴포넌트 만들자
    // this.commonStore.setLoading(false)
  };

  const makeTrialSite = () => {
    if (promotionCode !== "") {
      setShowSiteNewModal(true);
      setType("trial");
      setServiceBillUid(promotionCode);
    }
  };

  const makePaySite = () => {
    setShowSiteNewModal(true);
  };

  const makePromotionSite = () => {
    setShowSiteNewModal(true);
  };

  const hideModal = () => {
    setShowSiteNewModal(false);
  };

  const showCashReqModal = () => {
    setShowCashRequestDel(true);
  };

  const hideCashReqModal = () => {
    setShowCashRequestDel(false);
  };

  const closeCreateMsg = () => {
    setCreatePercent(0);
    setServiceNotice("");
  };

  const goPromiton = () => {
    goSitePromotion({});
  };

  const requestCashStatus = async (status: string) => {
    if (userCashStatus) {
      const param = {
        serviceCashUid: userCashStatus.serviceCashUid,
        status,
        msg: deleteCashReqMsg,
      };
      await updateCashStatus(param).then((res) => {
        if (res.status === "CANCEL") {
          notifySuccess(t("cashStatus.removeSuccess"));
          // setUserCashStatus(res);
          setIsDone(false);
          setDeleteCashReqMsg("");
          userCashStatusRefetch();
          // 전역상태 세팅 필요
          // setCashStatus(res.status);
          setShowCashRequestDel(false);
          goSiteType();
        } else if (res.status === "APPLY") {
          notifySuccess(t("cashStatus.requestNotic"));
          userCashStatusRefetch();
          goConsole();
        }
      });
    }
  };
  // console.log("unregisterPromotionList", unregisterPromotionList);
  // console.log("unregisterPayList", unregisterPayList);
  // console.log("userCashStatus", userCashStatus);
  return (
    <>
      {unregisterPayList && unregisterPromotionList && userCashStatus && (
        <ConsoleUI
          newSite={newSite}
          serviceList={serviceList ?? []}
          siteNxacList={siteNxacList ?? []}
          goDetail={goDetail}
          goList={goList}
          detailIndex={detailIndex}
          viewType={viewType}
          makeType={makeType}
          openEcoAdmin={() =>
            goEcoAdmin({
              domainName: serviceList ? serviceList[0].domainName : "",
            })
          }
          goEcoAdmin={
            guideDownloadModal
            // goEcoAdmin({
            //   domainName: serviceList ? serviceList[0].domainName : "",
            // })
          }
          openWrapsody={openWrapsody}
          openEco={() =>
            openEco({
              domainName: serviceList ? serviceList[0].domainName : "",
            })
          }
          promotionNotice={promotionNotice}
          serviceNotice={serviceNotice}
          modal={modal}
          newServiceName={newServiceName}
          toggleModalConfirmServerName={toggleModalConfirmServerName}
          toggleModalConfirmDelete={toggleModalConfirmDelete}
          confirmServiceName={confirmServiceName}
          confirmServiceDelete={confirmServiceDelete}
          handleChange={handleChange}
          makeTrialSite={makeTrialSite}
          makePaySite={makePaySite}
          makePromotionSite={makePromotionSite}
          isDone={isDone}
          showSiteNewModal={showSiteNewModal}
          hideModal={hideModal}
          type={type}
          serviceBillUid={serviceBillUid ?? ""}
          nowTime={nowTime}
          createPercent={createPercent}
          closeCreateMsg={closeCreateMsg}
          showMsgModal={showMsgModal}
          closeButtonGuide={closeButtonGuide}
          showGuideDownloadModal={showGuideDownloadModal}
          handleChangeGuide={handleChangeGuide}
          doNotOpenGuide={doNotOpenGuide}
          goPromiton={goPromiton}
          userCashStatus={userCashStatus}
          showCashRequestDel={showCashRequestDel}
          showCashReqModal={showCashReqModal}
          hideCashReqModal={hideCashReqModal}
          requestCashStatus={requestCashStatus}
          deleteCashReqMsg={deleteCashReqMsg}
          isUnregister={
            // 일반 & 프리미엄 중 하나라도 사이트 등록 안된것이 있는 경우
            unregisterPayList?.length !== 0 ||
            unregisterPromotionList?.length !== 0
          }
        />
      )}
    </>
  );
};

export default ConsoleContainer;
